<template>
  <el-scrollbar>
    <div v-loading="isLoading" class="dashboard-widget-list">
      <ul>
        <drag :class="$style['widget-templ-wrapper']" v-for="item in widgetList" :key="item.widgetTemplId" :transfer-data="item" @dragstart="onDragStart" @dragend="onDragEnd">
          <li>{{ item.widgetTemplName }}</li>
        </drag>
      </ul>
    </div>
  </el-scrollbar>
</template>

<script>
import { Drag } from 'vue-drag-drop';

import filter from 'lodash/filter';

import DashboardConst from '@/constants/dashboard';

import Base from '@/mixins/dashboard/base';

export default {
  name: 'WDashboardWidgetList',
  components: {
    Drag,
  },
  mixins: [Base],
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    widgetList() {
      return filter(this.widgetTempl, (widget) => widget.widgetTemplId !== 'EmptyWidget' && widget.showFlag === 'Y');
    },
  },
  methods: {
    onDragStart(data, evt) {
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.WIDGET_ADD_START, data, evt);
    },
    onDragEnd(data, evt) {
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.WIDGET_ADD_END, data, evt);
    },
  },
};
</script>

<style lang="scss">
.dashboard-widget-list {
  height: 100%;
  width: 100%;
  padding: 0px 20px;
}
</style>

<style module>
.widget-templ-wrapper li {
  border: 1px solid #e0e0e0;
  line-height: 40px;
  height: 40px;
  margin-bottom: 5px;
  background: #fff;
  font-size: 14px;
  font-weight: 500;
  color: #777;
  cursor: move;
  border-radius: 3px;
}

.widget-templ-wrapper li:before {
  content:'\2026';
  transform: rotate(-90deg);
  display: inline-block;
  margin-right: 20px;
  margin-left: -4px;
  font-size: 18px;
  color: #ddd; /* $palelinegray */
}

.widget-templ-wrapper li:hover {
  border: 1px solid #3a84fd;
  background: #3a84fd;
  color: #fff !important;
  box-shadow: 0 2px 2px -2px #d3d3d3; /* $dgray */
}

.widget-templ-wrapper li:hover:before {
  color: #fff; /* $luckygray */
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/frame/DashboardWidgetList.vue